// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-date-range/dist/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-date-range/dist/theme/default.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-international-phone/dist/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-country-state-city/dist/react-country-state-city.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

#app-container {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

* {
  box-sizing: border-box;
  outline: none;
}

.floating-panel-root {
  border-top-left-radius: 0.1875rem;
  border-top-right-radius: 0.1875rem;
  background-color: white;
  z-index: 100000;
}

.floating-panel-root.has-border {
  box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
  -webkit-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
}

.react-draggable {
  display: flex;
  align-items: center;
  justify-content: center;
}

`, "",{"version":3,"sources":["webpack://./../src/resources/css/main.css"],"names":[],"mappings":"AAKA;EACE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW;EACtC,wBAAwB,EAAE,mBAAmB;EAC7C,sBAAsB,EAAE,4BAA4B;EACpD,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB,EAAE,iFAAiF;AACtG;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["@import \"react-date-range/dist/styles.css\";\n@import \"react-date-range/dist/theme/default.css\";\n@import \"react-international-phone/style.css\";\n@import \"react-country-state-city/dist/react-country-state-city.css\";\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n}\n\n#app-container {\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  height: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n* {\n  box-sizing: border-box;\n  outline: none;\n}\n\n.floating-panel-root {\n  border-top-left-radius: 0.1875rem;\n  border-top-right-radius: 0.1875rem;\n  background-color: white;\n  z-index: 100000;\n}\n\n.floating-panel-root.has-border {\n  box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n  -webkit-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n  -moz-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n}\n\n.react-draggable {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
